import styled from "styled-components";
export const AllActionsStyle = styled.div``;
